"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Dialog = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styles = require("./styles");
var _Icon = require("../Basics/Icons/Icon");
var _IconButton = require("../Buttons/IconButton");
const _excluded = ["title", "onClose", "isLoading", "children"],
  _excluded2 = ["size", "children"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
const DialogHeader = _ref => {
  let {
      title,
      onClose,
      isLoading,
      children
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_styles.Header, _extends({
    className: 'vcs-ui__dialog__header'
  }, rest), title && /*#__PURE__*/_react.default.createElement(_styles.Title, null, title), children, onClose && /*#__PURE__*/_react.default.createElement(_IconButton.IconButton, {
    onClick: onClose,
    title: "close",
    style: {
      position: 'absolute',
      right: 8,
      top: 8
    }
  }, /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    icon: "close"
  })), isLoading && /*#__PURE__*/_react.default.createElement(_styles.LineLoading, null));
};
DialogHeader.propTypes = {
  /** Define this prop to add text at the left side of the header. */title: _propTypes.default.string,
  /** Define this prop to add a close button ( X ) will be placed at the right side of the header, executing this handler. */onClose: _propTypes.default.func,
  /** This will render the Line loading indication at the bottom of the header. */isLoading: _propTypes.default.bool,
  borderBottom: _propTypes.default.bool,
  /** Useful for custom headers. Don't specify `title` and `onClose` but add whatever in the header's children. */children: _propTypes.default.node
};
const withClassName = (className, Component) => {
  return props => /*#__PURE__*/_react.default.createElement(Component, _extends({
    className: className
  }, props));
};
class Dialog extends _react.default.Component {
  render() {
    const _this$props = this.props,
      {
        size = 'md',
        children
      } = _this$props,
      rest = _objectWithoutProperties(_this$props, _excluded2);
    return /*#__PURE__*/_react.default.createElement(_styles.Root, {
      role: "presentation",
      className: "vcs-ui__dialog__root"
    }, /*#__PURE__*/_react.default.createElement(_styles.Overlay, {
      role: "none presentation",
      className: "vcs-ui__dialog__overlay"
    }, /*#__PURE__*/_react.default.createElement(_styles.Wrapper, _extends({
      role: "dialog",
      className: "vcs-ui__dialog__wrapper",
      size: size
    }, rest), children)));
  }
}
exports.Dialog = Dialog;
_defineProperty(Dialog, "propTypes", {
  /** Defines width. Choose from presets:`xs | sm | md | lg`, or any valid CSS like `700px` */size: _propTypes.default.string,
  children: _propTypes.default.node
});
_defineProperty(Dialog, "Header", DialogHeader);
_defineProperty(Dialog, "Title", withClassName('vcs-ui__dialog__title', _styles.Title));
_defineProperty(Dialog, "Inner", withClassName('vcs-ui__dialog__inner', _styles.Inner));
_defineProperty(Dialog, "Buttons", withClassName('vcs-ui__dialog__buttons', _styles.Buttons));
_defineProperty(Dialog, "Block", withClassName('vcs-ui__dialog__block', _styles.Block));